module.exports = __webpack_public_path__ + "static/image/history/pc/202405.ver2_0_2.png?6ba772c2";